import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface GroupedEquipmentProps {
  equipment: Record<string, Record<string, string[]>>;
}

export default function GroupedEquipment({ equipment }: GroupedEquipmentProps) {
  if (!equipment || Object.keys(equipment).length === 0) {
    return <div className="text-gray-500">No equipment features available</div>;
  }

  return (
    <div className="space-y-6">
      {Object.entries(equipment).map(([mainCategory, subCategories]) => (
        <Card key={mainCategory}>
          <CardContent className="p-6">
            <h3 className="text-lg font-medium mb-4">{mainCategory}</h3>

            <Accordion type="multiple" className="w-full">
              {Object.entries(subCategories).map(([category, items], index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-base">
                    {category}
                    <Badge className="ml-2" variant="outline">
                      {Array.isArray(items) ? items.length : 0}
                    </Badge>
                  </AccordionTrigger>
                  <AccordionContent>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
                      {(Array.isArray(items) ? items : []).map((item, itemIndex) => (
                        <li key={itemIndex} className="text-sm">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
